// resources/js/admin/pages/module-pages/locales/NewLocalePage.tsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LocaleFormData } from "../../../types/features/Locale";

import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import useLocales from "../../../hooks/features/locales/useLocales";
import LocaleForm from "../../../components/shared/locales/LocalForm";

export default function NewLocalePage() {
    const navigate = useNavigate();
    const { createLocale } = useLocales();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = async (data: LocaleFormData) => {
        setIsLoading(true);
        const success = await createLocale(data);
        setIsLoading(false);
        if (success) {
            setIsSuccess(true);
            alertSuccess("Langue créée avec succès");
            navigate("/admin/locales");
        } else {
            alertError("Erreur lors de la création de la langue");
        }
    };

    return (
        <PageLayout title="Nouvelle langue" className="p-6 max-w-4xl mx-auto">
            <PageContainer>
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Nouvelle langue</h1>
                    <p className="text-gray-500 mt-1">Ajoutez une nouvelle langue disponible pour les sites</p>
                </div>
                <LocaleForm isSuccess={isSuccess} onSubmit={handleSubmit} isLoading={isLoading} />
            </PageContainer>
        </PageLayout>
    );
}